export * from './checks';
export * from './event';
export * from './extractors';
export * from './formatters';
export * from './time';
export * from './colors';
export * from './fragment-switch';

export const isDevelopment = process.env.NODE_ENV !== 'production';
